export const PROJECT_ID_KEY = 'projectId';
export const CLIENT_ID_KEY = 'clientId';
//# sourceMappingURL=feature-flag.js.map